import React from "react";
import { Navigate, useParams } from "react-router-dom";

import {
  resolveAppLinkTarget,
  type AppLinkType,
} from "../../../utils/portalAluno/appLinkRoutes";

interface AppLinkRedirectProps {
  type: AppLinkType;
}

// Traduz um link compartilhado pelo app (/curso/<código>, /trilha/<código>, ...) para a tela
// correspondente do Portal do Aluno. A rota fica fora da área autenticada: o destino leva o
// parâmetro de compartilhamento, que o LoginRedirect guarda para depois do login.
const AppLinkRedirect = ({ type }: AppLinkRedirectProps) => {
  const { encodedId = "" } = useParams<{ encodedId: string }>();
  const target = resolveAppLinkTarget(type, encodedId);

  if (!target) return <Navigate replace to="/app" />;

  return <Navigate replace to={target.to} state={target.state} />;
};

export default AppLinkRedirect;
